module.exports = __webpack_public_path__ + "img/rotate-left.0f3322a7.svg";